export default function createPropType(validate) {
  function checkType(isRequired, props, propName, componentName) {
    const componentNameStub = componentName || '<<anonymous>>';
    if (props[propName] == null) {
      if (isRequired) {
        return new Error(
          `Required \`${propName}\` was not specified in ` +
          `\`${componentNameStub}\`.`,
        );
      }
      return null;
    }
    return validate(props, propName, componentNameStub);
  }

  const chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
